"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var financejs_1 = require("financejs");

var finance = new financejs_1.Finance();

function calculateMonthlyRepayment(annualRate, termInYears, loanAmount, fees) {
  var rate = convertDecimalRateToFraction(annualRate, 2);
  var repayment = finance.PMT(rate / 12, termInYears * 12, -Math.abs(loanAmount + fees));
  return roundToTwoDecimals(repayment);
}

exports.calculateMonthlyRepayment = calculateMonthlyRepayment;

function convertDecimalRateToFraction(value, decimals) {
  return Number((value / 100).toExponential(decimals + 1));
}

exports.convertDecimalRateToFraction = convertDecimalRateToFraction;

function roundToTwoDecimals(num) {
  return parseFloat(num.toFixed(2));
}

exports.roundToTwoDecimals = roundToTwoDecimals;